"use client";
import { Modal } from "react-bootstrap";
import classes from "./FullScreenModal.module.css";
import { useState } from "react";

import FavoriteIcon from "../../UI/FavoriteIcon";
import { useAlertContext } from "@/context/alert";
import { ArrowLeft, ChevronLeft, ChevronRight, Share, X } from "react-feather";

const FullScreenModal = (props) => {
  const { listing, isFullscreen, setFullscreen } = props;

  const [viewSingle, setViewSingle] = useState(false);
  const [current, setCurrent] = useState(0);

  const { SET_ALERT } = useAlertContext();

  const copyToClipboard = () => {
    navigator?.clipboard.writeText(document.location.href);
    SET_ALERT({ msg: "Listing link copied!", type: "success" });
  };

  const nextHandler = () => {
    if (current === listing.images.length - 1) {
      setCurrent(0);
    } else setCurrent(current + 1);
  };

  const previousHandler = () => {
    if (current === 0) {
      setCurrent(listing.images.length - 1);
    } else setCurrent(current - 1);
  };

  const viewSingleHandler = (set, idx) => {
    if (idx) {
      setCurrent(idx);
    }
    setViewSingle(set);
  };

  return (
    <Modal show={isFullscreen} className="modal-fullscreen" fullscreen={true}>
      <section className={classes.header}>
        {viewSingle ? (
          <X
            strokeWidth={1}
            className={classes.closeIcon}
            onClick={() => viewSingleHandler(false)}
          />
        ) : (
          <ArrowLeft
            size={2}
            className={classes.backIcon}
            onClick={() => setFullscreen(null)}
          />
        )}

        {viewSingle ? (
          <div className={classes.imgCount}>
            <span>{current + 1}</span>/<span>{listing.images.length}</span>
          </div>
        ) : (
          ""
        )}

        <section className={classes.actionDiv}>
          <div className={classes.biShareDiv} onClick={copyToClipboard}>
            <Share strokeWidth={1} className={classes.biShare} size={15} />
            <div className={classes.shareText}> Share</div>
          </div>
          <FavoriteIcon
            listing={listing}
            noBorderClass={classes.noBorderClass}
          />
        </section>
      </section>
      <Modal.Body className={classes.maxWidth}>
        {!viewSingle ? (
          <section className={classes.gridImages}>
            {listing.images.slice(1).map((img, idx) => (
              <img
                key={idx}
                src={img}
                alt={listing.title ? listing.title : "listing"}
                className={classes.img}
                fetchPriority="low"
                height="100%"
                onClick={() => {
                  viewSingleHandler(true, idx + 1);
                }}
              />
            ))}
          </section>
        ) : (
          <div className={classes.fullImage}>
            <img
              src={listing.images[current]}
              alt={listing.title ? listing.title : "listing"}
              className={classes.fullImg}
              fetchPriority="low"
              height="100%"
              width="auto"
            />
            <div className={classes.next} onClick={() => nextHandler()}>
              <ChevronRight className={classes.arrow} />
            </div>
            {current !== 0 && (
              <div
                className={classes.previous}
                onClick={() => previousHandler()}
              >
                <ChevronLeft className={classes.arrow} />
              </div>
            )}
          </div>
        )}
      </Modal.Body>
      {/* 
      <div className={classes.fullImage}>
        <GrClose
          className={classes.closeIcon}
          onClick={() => setFullscreen(null)}
        />
        <img
          src={listing.images[current]}
          alt={listing.title ? listing.title : "listing"}
          className={classes.fullImg}
          fetchPriority="low"
          height="100%"
          width="auto"
        />
        <div className={classes.next} onClick={() => nextHandler()}>
          <GrNext className={classes.arrow} />
        </div>
        {current !== 0 && (
          <div className={classes.previous} onClick={() => previousHandler()}>
            <GrPrevious className={classes.arrow} />
          </div>
        )}
      </div> */}
    </Modal>
  );
};

export default FullScreenModal;
